module.exports = __webpack_public_path__ + "img/img129.48fa80a7.svg";